/**
 * restart-algorithm-broadcast.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

@validateFor(MessageTag.BCST_RESTART_ALGORITHM)
export class RestartAlgorithmBroadcast extends IncomingMessage
{
  /** This message type's unique message tag. */
  public tag : MessageTag = MessageTag.BCST_RESTART_ALGORITHM;

  @validateAs("boolean")
  public maybeLostData : boolean;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/restart-algorithm-broadcast.ts